import { SEO_KEYWORDS, SEO_NO_LAYOUT_KEY, SEO_NO_MEDIUM_KEY } from '../constants/seo.keywords';
export const seoGetCurrentKeywords = (layoutKey = false, mediumKey = SEO_NO_MEDIUM_KEY) => {
    return SEO_KEYWORDS[mediumKey][layoutKey !== false ? layoutKey : SEO_NO_LAYOUT_KEY];
};
